module.exports = __webpack_public_path__ + "img/毛诃子.329ad819.jpg";